import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { authAtom } from "../state";
import { isLoggedIn } from "../api/client";

const ProtectedRoute = ({ children }) => {
  const auth = useRecoilValue(authAtom);
  let location = useLocation();

  // This is a quick sanity check to ensure presence of the auth object and the corresponding ID token
  // There will be another check on HTTP return codes when making any API call, to check for indications
  // that the idToken has expired and force the user to re-authenticate.
  if (!isLoggedIn(auth)) {
    // not logged in so redirect to login page with the return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
